/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <section class="wrapp-coupon">
    <div class="enter-coupon" :class="{ 'is-valid': cartCoupon }">
      <div class="coupon-title">
        {{$t('enter-coupon')}}
      </div>
      <b-form class="wrapp-coupon__form">
        <div class="form-wrapper">
          <b-form-group>
            <base-input
              name="coupon"
              v-model.trim="coupon"
              type="text"
              classInput="rounded"
              v-validate="'required'"
              :validations="[
                {
                  condition: errors.has('coupon'),
                  text: errors.first('coupon')
                }
              ]"
            >
            </base-input>
          </b-form-group>
          <div class="wrapp-submit">
            <button type="submit" class="btn btn-secondary btn-secondary-small btn-secondary-with-icon btn-rounded justify-content-between" @click.prevent="submitForm">
              <span class="text">{{ submitLabel }}</span>
              <svg class="o-icon"><use xlink:href="#check"></use></svg>
            </button>
          </div>
        </div>
      </b-form>
    </div>
  </section>
</template>

<script>
import BaseInput from 'theme/components/Form/BaseInput'
import { toast } from 'theme/modules/notifications'

export default {
  name: 'Coupon',
  inject: ['$validator'],
  data () {
    return {
      temporaryCouponValue: ''
    }
  },
  computed: {
    cartCoupon () {
      return this.$store.getters['cart/coupon']
    },
    coupon: {
      get () {
        if (this.cartCoupon.length) {
          return this.cartCoupon
        } else {
          return this.temporaryCouponValue || ''
        }
      },
      set (newValue) {
        this.temporaryCouponValue = newValue
      }
    },
    submitLabel () {
      let submitLabel = this.$t('apply')
      if (this.cartCoupon) {
        submitLabel = this.$t('remove')
      }
      return submitLabel
    }
  },
  methods: {
    submitForm () {
      const _this = this
      return this.$validator.validate()
        .then((isValid) => {
          if (isValid) {
            this.$emit('loading', true)
            return this.$store.dispatch('cart/addCoupon', this.coupon)
              .then(res => {
                let errorsCall = res.errors
                if (errorsCall && errorsCall.length) {
                  this.$emit('loading', false)
                  toast.error(this.$t('error-coupon'))
                } else {
                  // success
                  return this.$store.dispatch('cart/totals')
                    .finally(() => {
                      toast.success(this.$t('coupon-successfully-added'))
                      this.$emit('loading', false)
                    })
                }
              })
              .catch(error => {
                const msg = error.response.data && error.response.data.message ? _this.$t(error.response.data.message) : _this.$t('error-coupon')
                toast.error(msg)
                this.$emit('loading', false)
              })
              .finally(() => {
                this.coupon = ''
                this.$validator.reset()
              })
          }
        })
    },
    removeCoupon (coupon) {
      const _this = this
      this.$store.commit('ui/showLoader')
      this.$store.dispatch('cart/deleteCoupon', { cart_id: this.$store.state.cart.cartId, couponId: coupon.coupon_item_id })
        .catch(error => {
          const msg = error.response.data && error.response.data.message ? _this.$t(error.response.data.message) : _this.$t('error-coupon')
          toast.error(msg)
          this.$emit('loading', false)
        })
        .then(() => {
          _this.coupon = ''
          return this.$store.dispatch('cart/totals')
            .finally(() => {
              this.$emit('loading', false)
              toast.success('coupon-successfully-removed')
            })
        })
    }
  },
  components: {
    BaseInput
  }
}
</script>
